import { useEffect, useRef, useState } from "react";

interface InviteModalProps {
  isOpen: boolean;
  username: string;
  onUsernameChange: (username: string) => void;
  onInvite: () => void;
  onClose: () => void;
  notification?: string;
}

export default function InviteModal({
  isOpen,
  username,
  onUsernameChange,
  onInvite,
  onClose,
  notification,
}: InviteModalProps) {
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);
  const prevIsOpen = useRef(isOpen);

  useEffect(() => {
    if (isOpen && !prevIsOpen.current) {
      setMounted(true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => setVisible(true));
      });
    } else if (!isOpen && prevIsOpen.current) {
      setVisible(false);
      const timer = setTimeout(() => setMounted(false), 200);
      prevIsOpen.current = isOpen;
      return () => clearTimeout(timer);
    }
    prevIsOpen.current = isOpen;
  }, [isOpen]);

  if (!mounted) return null;

  return (
    <div
      className={`modal-overlay ${visible ? "visible" : ""}`}
      onClick={onClose}
      onKeyDown={(e) => {
        if (e.key === "Escape") onClose();
      }}
      role="button"
      tabIndex={-1}
    >
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">invite a friend</div>
        <input
          type="text"
          placeholder="username"
          value={username}
          onChange={(e) => onUsernameChange(e.target.value)}
          className={`auth-input ${notification ? "has-error" : ""}`}
        />
        {notification && <div className="modal-notification">{notification}</div>}
        <div className="modal-footer">
          <button type="button" onClick={onClose} className="btn btn-danger">
            cancel
          </button>
          <button type="button" onClick={onInvite} className="btn btn-primary">
            invite
          </button>
        </div>
      </div>
    </div>
  );
}
